import { Constructor } from "@skylab-shared/types";
import { MS_PER_SECOND } from "@skylab-shared/utils";

export interface ToastOptions {
    type?: ToastType;
    timeout?: number;
    isModal?: boolean;
    closeable?: boolean;
    componentName?: Constructor<Toast>;
    text?: string;
    data?: any;
    onClose?: Function;
}

export interface Toast {
    onClose: () => void;
    options: ToastOptions;
}

export enum ToastType {
    Success = 1,
    Error = 2
}

export enum ToastDelay {
    None = 0,
    VeryShort = MS_PER_SECOND * 2,
    Short = MS_PER_SECOND * 4,
    Regular = MS_PER_SECOND * 8,
    Long = MS_PER_SECOND * 10,
    VeryLong = MS_PER_SECOND * 12
}

export type ToastService = {
    show(options: ToastOptions): () => void;
};
